import PropTypes from "prop-types";

import { FlexContainers, Paragraph2 } from "../../components";
import { Placeholder, ViewOnlyContainer } from "./styled";

const ViewOnlyInputValues = ({ value, placeholder }) => {
  return (
    <ViewOnlyContainer Container={FlexContainers.FlexRowStart} width="100%">
      {value !== "" ? (
        <Paragraph2>{value}</Paragraph2>
      ) : (
        <Placeholder>{placeholder}</Placeholder>
      )}
    </ViewOnlyContainer>
  );
};

ViewOnlyInputValues.propTypes = {
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  placeholder: PropTypes.string
};

export default ViewOnlyInputValues;
